module.exports = __webpack_public_path__ + "img/t8.15089459.jpg";